function ScenarioCard({ scenario, onLoad, isActive }) {
  function fmt(n) {
    if (!n && n !== 0) return '—';
    const abs = Math.abs(n);
    return (n<0?'-':'') + (abs>=1000?`$${(abs/1000).toFixed(1)}k`:`$${abs.toFixed(0)}`);
  }

  const date = new Date(scenario.created_at).toLocaleDateString();

  return (
    <div
      onClick={() => onLoad(scenario)}
      style={{
        background: isActive ? '#EFF6FF' : '#fff',
        border: `2px solid ${isActive ? '#0369A1' : '#E2E8F0'}`,
        borderRadius: 8, padding: '1rem',
        cursor: 'pointer', transition: 'border-color 0.15s',
        minWidth: 180, flex: 1,
      }}
    >
      <div style={{ fontWeight:700, color:'#1B2A4A', marginBottom:'0.25rem',
                     fontSize:'0.95rem' }}>
        {scenario.name}
      </div>
      <div style={{ color:'#64748B', fontSize:'0.75rem', marginBottom:'0.75rem' }}>
        {scenario.change_count} changes · {date}
      </div>
      <div style={{ fontSize:'0.8rem', color:'#475569' }}>
        Snapshot: {scenario.snapshot_label}
      </div>
      {isActive && (
        <div style={{ marginTop:'0.5rem', fontSize:'0.75rem',
                      color:'#0369A1', fontWeight:600 }}>
          ✓ Currently loaded
        </div>
      )}
    </div>
  );
}

export default ScenarioCard;
